import { render, staticRenderFns } from "./Particles.vue?vue&type=template&id=549286aa&scoped=true&"
import script from "./Particles.vue?vue&type=script&lang=js&"
export * from "./Particles.vue?vue&type=script&lang=js&"
import style0 from "./Particles.vue?vue&type=style&index=0&id=549286aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549286aa",
  null
  
)

export default component.exports